var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleBroken0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 9.23806V10.0047C18.3321 11.8017 17.7503 13.5503 16.6743 14.9896C15.5983 16.4289 14.0859 17.4818 12.3626 17.9913C10.6394 18.5008 8.79755 18.4396 7.1119 17.8169C5.42624 17.1941 3.98705 16.0431 3.00897 14.5356C2.03089 13.0281 1.56633 11.2448 1.68457 9.45166C1.80281 7.65853 2.49751 5.95167 3.66507 4.58562C4.83263 3.21958 6.41049 2.26755 8.16333 1.87152C9.91617 1.47549 11.7501 1.65668 13.3915 2.38806M18.3332 3.33329L9.99984 11.675L7.49984 9.17496",
    stroke: "#69C23F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBroken0);
export default __webpack_public_path__ + "static/media/check-circle-broken0.22bf5924eed4f9c1e672984f5b5f3b3f.svg";
export { ForwardRef as ReactComponent };